export { default as FiltersFacultyMobile } from "./FiltersFacultyMobile/FiltersFacultyMobile";
